import moment from "moment";
export const removeHours = date => {
  date.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
  return date;
};

export const isToday = date => {
  return date.isSame(moment(new Date()), "day");
};

const formatTime = time => {
  let seconds = Math.floor(time / 1000);
  let minutes = Math.floor(time / 60000);
  let hours = Math.floor(time / 3600000);
  seconds = seconds - minutes * 60;
  minutes = minutes - hours * 60;

  return `${hours < 10 ? 0 : ""}${hours}:${minutes < 10 ? 0 : ""}${minutes}:${
    seconds < 10 ? 0 : ""
  }${seconds}`;
};



// WEBPACK FOOTER //
// ./src/utils/helpers/date.js